export default __webpack_public_path__ + "static/media/Transfer line 2.f38a5a48.mp3";